import gql from 'graphql-tag';

import { companyFragment } from '~/shared/graphql-queries/companies/index';

export default gql`
  mutation updateByIdCompanyMutation(
    $_id: MongoID!
    $record: UpdateByIdCompanyInput!
  ) {
    updateByIdCompanyMutation(_id: $_id, record: $record) {
      recordId
      record {
        ...CompanyFragment
      }
      message
      title
    }
  }
  ${companyFragment}
`;
